import axiosConfig from '../modules/axiosConfig'
import utils from '../modules/utils'
const HTTP = axiosConfig.HTTP

// state
const state = {
  loadingIdDropdown: false
}

// getters
const getters = {
  getLoadingIdDropdown () {
    return state.loadingIdDropdown
  }
}

// actions
const actions = {
  async getIdDropdown ({ commit, rootState }, data) {
    commit('LOADING_ID_DROPDOWN_FINISHED', false)
    const config = rootState.appConfig.configFile
    const appParams = JSON.parse(sessionStorage.getItem('appParams'))
    // const appProgram = sessionStorage.getItem('appProgram')
    const storageAppToken = sessionStorage.getItem('token')
    const hashToken = utils.SHA256(appParams.entidad + storageAppToken + appParams.canal)
    let body = {}
    body = Object.assign({}, {
      runService: {
        opData: {
          avanzar: false,
          businesstimeout: '',
          canal: config.canal,
          claveFin: '',
          claveInicio: '',
          entidad: config.entidad,
          idioma: 'ES',
          indMasDatos: 'N',
          oficina: '',
          pantPagina: false,
          retroceder: false,
          mainUser: appParams.mainUser,
          securityToken: hashToken
        },
        eEntrada: {
          desctidc: '',
          tipidcli: '',
          tipidext: ''
        }
      }
    })
    try {
      const response = await HTTP.post(config.endpoints.getListID, body)
      sessionStorage.setItem('token', response.data.runServiceResponse.return.securityToken)
      commit('LOADING_ID_DROPDOWN_FINISHED', true)
      if (response.data.runServiceResponse.return.retorno === '039') {
        commit('SET_ERROR', {
          isError: true,
          isFatal: true,
          msg: 'La sesión ha expirado. Reinicie el registro.'
        })
      }
      if (response.data.runServiceResponse.return.retorno === '021') {
        commit('SET_ERROR', {
          isError: true,
          isFatal: true,
          msg: 'Token de seguridad incorrecto.'
        })
      }
      return response.data.runServiceResponse.return
    } catch (error) {
      commit('SET_ERROR', {
        isError: true,
        isFatal: false,
        msg: error
      }, { root: true })
    }
  }
}

// mutations
const mutations = {
  'LOADING_ID_DROPDOWN_FINISHED' (state, actions) {
    state.loadingIdDropdown = actions
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
